import { differenceWith, flatten } from 'lodash';
import { SchoolProfile } from '@schools/app/types';

const profileGroups = (category) => {
  if (!category) return [];

  const groups = [...category.groups];
  const profilesPresent = flatten(groups.map((group) => group.profiles));
  const remainingProfiles = differenceWith(category.profiles, profilesPresent, (a: SchoolProfile, b: SchoolProfile) => a.slug === b.slug);

  if (remainingProfiles.length) {
    const name = category.groups.length ? 'Other Schools' : 'Schools';

    return [
      ...groups,
      { name, profiles: remainingProfiles }
    ];
  } else {
    return groups;
  }
};

export default profileGroups;
